import React from 'react';
import Card from './ui/Card';
import SectionWrapper from './ui/SectionWrapper';

const outcomes = [
  {
    quote:
      'The program flow is fantastic; it takes you from the absolute basics to advanced production, helping you think beyond the script and understand the entire business of the film.',
    name: 'Rohin Kumar',
    role: 'Software Developer, Writer',
    location: 'Bengaluru',
    badge: 'From Basics to Business of Film',
  },
  {
    quote:
      'Cinepreneur provided the perfect stage to showcase my skills; the hands-on projects and deep dive into the production process gave me the confidence I needed to truly own my craft.',
    name: 'Vaishnavi Reddy',
    role: 'Content Creator',
    location: 'Hyderabad',
    badge: 'Hands-On & Production Ready',
  },
  {
    quote:
      'The program condensed years of theoretical and practical film knowledge into a short span, giving me the tools to transition from finance to building a media-first business.',
    name: 'Aravinth',
    role: 'Media Entrepreneur',
    location: 'Chennai',
    badge: 'Finance to Media-First Business',
  },
  {
    quote:
      'The structured approach to storytelling and mentorship from industry experts makes this the most advantageous choice for anyone serious about turning their creative passion into a scalable business.',
    name: 'Rubina',
    role: 'Writer & Entrepreneur',
    location: 'Mumbai',
    badge: 'Passion to Scalable Business',
  },
];

export default function RealOutcomesSection() {
  return (
    <SectionWrapper>
      <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-gray-900 leading-tight">
          Real outcomes.
          <br />
          <span className="italic text-[#C8A75B] font-medium">Real people.</span>
        </h2>
        <p className="text-sm text-gray-500 max-w-sm">
          Not testimonials. Transformations.
          <br />
          Stories from creators using the platform to break through.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {outcomes.map((o) => (
          <Card key={`${o.name}-${o.badge}`} className="bg-[#FCFCFB] p-5">
            <span className="text-3xl leading-none text-[#D6C299]">“</span>
            <p className="mt-2 text-sm leading-relaxed text-gray-700 min-h-[120px]">{o.quote}</p>

            <div className="mt-5 flex items-center gap-3">
              <div className="h-9 w-9 rounded-full bg-gray-200" />
              <div>
                <p className="text-sm font-semibold text-gray-900">{o.name}</p>
                <p className="text-xs text-gray-500">
                  {o.role} • {o.location}
                </p>
              </div>
            </div>

            <p className="mt-4 text-[11px] uppercase tracking-wide font-semibold text-[#B08A3B]">
              {o.badge}
            </p>
          </Card>
        ))}
      </div>
    </SectionWrapper>
  );
}

